import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './components/AuthContext';
import LoginPage from './components/LoginPage';
import WelcomePage from './components/WelcomePage';
import ClubRegistrationPage from './components/club_portal/club_registrations/ClubRegistrationPage';
import ClubPortalRoutes from './components/routes/ClubPortalRoutes';
import ProfilePage from './components/profiles/ProfilePage';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<WelcomePage />} />
        
        <Route 
          exact path="/login"
          element={<AuthProvider><LoginPage /></AuthProvider>}
        />
        <Route 
          exact path="/club_register"
          element={<AuthProvider><ClubRegistrationPage /></AuthProvider>}
        />
        
        

        {/* Corrected Route: Specifically handles all nested club portal routes */}
        <Route 
          path="/club_portal/*" 
          element={<AuthProvider><ClubPortalRoutes /></AuthProvider>} 
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
